// Central configuration for all image arrays and their positioning
// Change image positions and zoom levels here for all slideshows across the website
//
// Position options (pos): 'center', 'top', 'bottom', 'left', 'right', or percentages like '50% 0%', '75% 50%'
// Zoom options (size): 'cover' (default - fills container, may crop), 'contain' (shows full image, may have gaps),
//                      or percentages like '120%' (zoom in), '80%' (zoom out), '150% 100%' (width height)

export const buildImgArray = [
    {img: '/imgs/nov2025Imgs/weBuildBrands/premioGuideline.jpg', pos: '40% 0%', size: 'cover'},
    {img: '/imgs/nov2025Imgs/PXL_20240809_195629365.jpg', pos: 'center', size: 'cover'},
    {img: '/imgs/nov2025Imgs/weBuildBrands/Stef.jpg', pos: 'center', size: 'cover'},
    {img: '/imgs/nov2025Imgs/weBuildBrands/HIQ.jpg', pos: 'center', size: 'cover'},
    {img: '/imgs/nov2025Imgs/weBuildBrands/table.jpg', pos: 'center', size: 'cover'},
    {img: '/imgs/nov2025Imgs/weBuildBrands/Vulco.jpg', pos: 'center', size: 'cover'},
    {img: '/imgs/nov2025Imgs/weBuildBrands/Logos.jpg', pos: 'center', size: 'cover'},
];

export const aboutUsImgArray = [
    {img: '/imgs/nov2025Imgs/aboutUs/guyWork_comp.jpg', pos: '90% 0%', size: 'cover'},
    {img: '/imgs/nov2025Imgs/aboutUs/sebDesk_comp.jpg', pos: '0% 50%', size: 'cover'},
    {img: '/imgs/nov2025Imgs/aboutUs/stairsPlant_comp.jpg', pos: '90% 50%', size: 'cover'}
];

export const visionImgArray = [
    {img: '/imgs/nov2025Imgs/visionPurpose/meeting_room_new_o.jpg', pos: '50% 50%', size: 'cover'},
    {img: '/imgs/nov2025Imgs/visionPurpose/colours_new_o.jpg', pos: 'center', size: 'cover'},
    {img: '/imgs/newImgs/IMG_2848.jpg', pos: 'center', size: 'cover'},
    {img: '/imgs/nov2025Imgs/visionPurpose/browntable_new_o.jpg', pos: '25% 0%', size: 'cover'}
];

export const designStrategyImgArray = [
    {img: '/imgs/nov2025Imgs/designStrategy/web/sebPi_comp.jpg', pos: 'center', size: 'cover'},
    {img: '/imgs/nov2025Imgs/designStrategy/web/kiosks_comp.jpg', pos: 'center', size: 'cover'},
    {img: '/imgs/nov2025Imgs/designStrategy/web/kioskBin_comp.jpg', pos: '25% 50%', size: 'cover'},
    {img: '/imgs/nov2025Imgs/designStrategy/web/kioskDismantled_comp.jpg', pos: 'center', size: 'cover'}
];

// Mobile-specific images for Design & Strategy section
export const designStrategyImgArrayMobile = [
    {img: '/imgs/nov2025Imgs/designStrategy/mobile/IMG_2930.JPG', pos: 'center', size: 'cover'},
    {img: '/imgs/nov2025Imgs/designStrategy/mobile/kiosks_comp.jpg', pos: 'center', size: 'cover'},
    {img: '/imgs/nov2025Imgs/designStrategy/mobile/kioskDismantled_comp.jpg', pos: 'center', size: 'cover'}
];

